import React from 'react';
import {colors} from '../theme/tokens/colors';

export interface CryptoIconProps {
  color?: keyof typeof colors;
  size?: number;
}

export const CryptoIcon = React.memo<CryptoIconProps>(
  ({color = 'outlines', size = 18}) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
        fill={colors[color] || color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.80005 4H8.80005V5.32283C8.93605 5.30758 9.07485 5.2998 9.21605 5.2998C9.24417 5.2998 9.27217 5.30011 9.30005 5.30072V4H10.3V5.46758C11.3239 5.80643 12.0363 6.63944 12.142 7.7918H10.91C10.798 6.9098 10.182 6.2518 9.18805 6.2518C7.90005 6.2518 7.04605 7.3858 7.04605 8.8838C7.04605 10.4938 7.91405 11.5438 9.21605 11.5438C10.21 11.5438 10.868 10.9698 10.994 10.0038H12.184C12.0872 11.134 11.4358 11.9911 10.3 12.327V13.7998H9.30005V12.4794C9.24934 12.481 9.198 12.4818 9.14605 12.4818C9.0294 12.4818 8.91396 12.4769 8.80005 12.467V13.7998H7.80005V12.2348C6.63204 11.7704 5.80005 10.6515 5.80005 8.8838C5.80005 7.31698 6.60456 6.11446 7.80005 5.58919V4Z"
        fill={colors[color] || color}
      />
    </svg>
  ),
);
